import type { Store } from 'vuex'
import type { IndexClientProvider } from './interfaces'
import { interfaces } from 'inversify'
import { TYPES } from '../config/inversify.types'
import { INDEX_CONSTS } from '../store/index/index.consts'
import Context = interfaces.Context

export function getPlatformIndexClientProvider({ container }: Context): IndexClientProvider {
  return id => {
    const store = container.get<Store<unknown>>(TYPES.Store)
    return store.dispatch(`${INDEX_CONSTS.moduleName}/${INDEX_CONSTS.actions.getClient}`, id)
  }
}
